export default "__VITE_ASSET__iV_IMGW9__"